module.exports = __webpack_public_path__ + "img/chess-clock-flip.6e3da0ba.svg";